// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__c2riO","name":"Header_name__3lCsk","birthday":"Header_birthday__3sLW9","skeleton":"Header_skeleton__3Z-6m"};